import React from "react";
import { intl } from "LocaleWrapper";
import DataFormat from "../utils/DataFormat";
import usePopover from "components/hooks/usePopover";
import { IconButton, Popover } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { User } from "__generated__/graphql";
import { RelationLink, UserLink } from "utils/LinkUtils";
import { ContractHistoryItem } from "types/index";

const ContractRecipient = ({ contractHistoryItem }: { contractHistoryItem: ContractHistoryItem }) => {

	const { popoverProps, onPopoverOpen } = usePopover({
		trigger: "click",
	});

	const hasRecipient = contractHistoryItem.recipientUser?.id || contractHistoryItem.recipientRelation?.id || contractHistoryItem.recipientContact?.id;

	return (
		<div style={{ alignItems: "center", display: "flex" }}>
			<span style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
				{contractHistoryItem.recipientUser?.email || contractHistoryItem.recipientRelation?.email || contractHistoryItem.recipientContact?.email || contractHistoryItem.recipientEmail || intl.formatMessage({ id: "UNKNOWN" })}
			</span>

			<React.Fragment>
				<Popover {...popoverProps}>
					<div style={{ padding: 16 }}>
						<React.Fragment>
							<div>
								{contractHistoryItem.recipientUser && (
									<UserLink user={contractHistoryItem.recipientUser as User} />
								)}

								{contractHistoryItem.recipientRelation && (
									<RelationLink relation={contractHistoryItem.recipientRelation} />
								)}

								{contractHistoryItem.recipientContact && (
									<React.Fragment>
										{DataFormat.contactName(contractHistoryItem.recipientContact)}
									</React.Fragment>
								)}
							</div>

							{(
								(contractHistoryItem.recipientUser && !contractHistoryItem.recipientUser.email) ||
								(contractHistoryItem.recipientRelation && !contractHistoryItem.recipientRelation.email) ||
								(contractHistoryItem.recipientContact && !contractHistoryItem.recipientContact.email)
							)  && (
								<div>
									<small>
										{intl.formatMessage({ id: "RECIPIENT_NO_EMAIL" })}
									</small>
								</div>
							)}
						</React.Fragment>
					</div>
				</Popover>

				{(hasRecipient) && (
					<IconButton size="small" onClick={onPopoverOpen}>
						<InfoIcon />
					</IconButton>
				)}
			</React.Fragment>
		</div>
	);
};

export default ContractRecipient;
